import { FC } from 'react';
import { useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import Header from '../../../common/Header/Header';
import { showToast } from '../../../components/Toast/Toast';
import { useGetRecipe, useGetRecipeDetails } from '../../../services/recipe/recipe.service';
import { useFetchErrorToast } from '../../../utils/useFetchErrorToasts/useFetchErrorToast';
import EditRecipeForm from "./EditRecipeForm";

const EditRecipe: FC = () => {
  const queryClient = useQueryClient();
  const { recipeId: recipeIdParam } = useParams<{ recipeId: string }>();
  const recipeId = +(recipeIdParam ?? '-1');

  const {
    data: getRecipeResponse,
    isError: getRecipeIsError,
    error: getRecipeError
  } = useGetRecipe({ recipeId });
  const recipe = getRecipeResponse?.data;

  const {
    data: getRecipeDetailsResponse,
    isError: getRecipeDetailsIsError,
    error: getRecipeDetailsError
  } = useGetRecipeDetails({ recipeId });
  const recipeDetails = getRecipeDetailsResponse?.data;

  useFetchErrorToast([
    {
      label: 'Error fetching Recipe data',
      id: 'recipeDataFetchError',
      isError: getRecipeIsError,
      error: getRecipeError
    },
    {
      label: 'Error fetching Raw Products associated with this recipe',
      id: 'recipeDetailsFetchError',
      isError: getRecipeDetailsIsError,
      error: getRecipeDetailsError
    }
  ]);

  const invalidateQueriesAndShowToast = () => {
    queryClient.invalidateQueries(['getRecipe', recipeId]);
    queryClient.invalidateQueries(['getRecipeDetails', recipeId]);
    showToast({
      label: 'Recipe has been updated successfully',
      id: 'updateRecipeSuccess'
    });
  }

  return (
      <>
        <Header
            breadcrumb={{ label: 'Back To All Recipes', to: '/recipes' }}
            title={`Recipe ${recipe?.recipeId ?? ''} - ${recipe?.description ?? ''}`}
        />
        {!!recipe && !!recipeDetails && (
            <EditRecipeForm
                recipe={recipe}
                recipeDetails={recipeDetails}
                onSuccess={invalidateQueriesAndShowToast}
            />
        )}
      </>
  );
};

export default EditRecipe;
